import { Endpoint, Route } from '@philips-emr/hpms-stipulator-commons';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import HistoryService from '@philips-emr/tws-core/lib/services/history-service';

import BaseController from '../BaseController';

@Controller({ fragment: 'cartao-consultar', component: 'panel-consultar-cartao' })
class CartaoConsultarController extends BaseController {

  @OnMount({ target: ['panel-consultar-cartao'] })
  onMount(): void {
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario });
    this.checkStatus();
  }

  checkStatus(): void {
    const { nrSeqBeneficiario, nrSeqContrato } = this.historyService.getCurrentRouteParams();

    void HttpService.get(Endpoint.GET.CARTAO_STATUS, { nrSeqBeneficiario, nrSeqContrato })
      .then(response => {
        const status = response.body;

        switch (status) {
          case 'N':
            HistoryService.push(Route.CARTAO_SOLICITAR, { nrSeqBeneficiario });
            break;
          case 'CR':
            HistoryService.push(Route.CARTAO_CONFIRMAR, { nrSeqBeneficiario });
            break;
        }

      });
  }

}
export default CartaoConsultarController;
